import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { FormControlType } from '@/types';
import { FieldValues, Path } from 'react-hook-form';

interface FormInputProps<T extends FieldValues> {
  control: FormControlType<T>;
  name: Path<T>;
  label: string;
  placeholder: string;
  disabled: boolean;
  type?: string;
}

export const FormInput = <T extends FieldValues>({
  control,
  name,
  label,
  placeholder,
  disabled,
  type = 'text',
}: FormInputProps<T>) => (
  <FormField
    control={control}
    name={name}
    render={({ field }) => (
      <FormItem className="w-full">
        <FormLabel>{label}</FormLabel>
        <FormControl>
          <Input
            {...field}
            disabled={disabled}
            placeholder={placeholder}
            type={type}
          />
        </FormControl>
        <FormMessage />
      </FormItem>
    )}
  />
);
